export default "__VITE_ASSET__5d1b072a__"